import type { ViewerAnnotationState } from '@/lib/annotationAdapter';

/** Filter dropdown order aligned with doctor annotation class order. */
export const FILTER_BY_LABEL_VALUES = [
  'NILM',
  'ASC-US',
  'LSIL',
  'ASC-H',
  'HSIL',
  'SCC',
  'Normal',
  'Abnormal',
  'Unknown',
] as const;

export function matchesAnnotationLabelFilter(
  ann: Pick<ViewerAnnotationState, 'label'>,
  filter: string | 'ALL',
): boolean {
  if (filter === 'ALL') return true;
  const label = (ann.label || '').trim();
  if (filter === 'NILM') return label === 'NILM' || label === 'Normal';
  if (filter === 'ASC-US') return label === 'ASC-US' || label === 'ASCUS';
  if (filter === 'ASC-H') return label === 'ASC-H' || label === 'ASCH';
  return label === filter;
}
